module.exports = __webpack_public_path__ + "MaterialIcons-Regular.a37b0c01c0baf1888ca8.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/iconfont/MaterialIcons-Regular.ttf
// module id = 642
// module chunks = 0